import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const CommentListSearchBar: React.FC<Props> = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="px-3 py-2">
      <div className="flex items-center gap-2 rounded-md border border-gray-400 px-3 py-1.5 text-sm text-gray-600">
        <FontAwesomeIcon icon={faMagnifyingGlass} className="shrink-0 text-gray-600" />
        <input
          type="text"
          aria-label={t('viewModel.commentList.searchPlaceholder')}
          className="min-w-0 flex-1 bg-transparent text-gray-800 outline-none placeholder:text-gray-400"
          placeholder={t('viewModel.commentList.searchPlaceholder')}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
};
